var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{class:['footer',  _vm._isMobile()?'mobile':'']},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.tenantInfo.footer)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }